export const ALL_ORGS_IDENTIFIER = 'All Organizations';
export const ALL_GROUPS_IDENTIFIER = 'All Groups';
export const NO_GROUPS_IDENTIFIER = 'No Groups';
